import ApiService from "@/core/services/api.service";
import {CANDIDATE_TEACHER, UPDATE_CANDIDATE_TEACHER} from "../course/classes.module";
import {DELETE_QUESTION} from "../support/question.module";

const state = {};
const getters = {};
export const GET_REGION = "region";
export const CREATE_REGION = "create_region";
export const UPDATE_REGION = "update_region";
export const DELETE_REGION = "delete_region";
export const HISTORY_REGION = "region/history";

const actions = {

    [GET_REGION](context, payload) {
        return new Promise(resolve => {
            ApiService.query(GET_REGION, payload).then(({data}) => {
                resolve(data);
            }).catch((response) => {
                console.log(response)
            });
        })
    },

    [CREATE_REGION](context, payload) {
        return new Promise((resolve,reject) => {
            ApiService.post(GET_REGION, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },
    [UPDATE_REGION](context, payload) {
        return new Promise((resolve,reject) => {
            ApiService.put(`${GET_REGION}/${payload.id}`, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },
    [DELETE_REGION](context, id) {
        return new Promise((resolve,reject) => {
            ApiService.delete(GET_REGION, id).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },
    [HISTORY_REGION](context, payload) {
        return new Promise((resolve,reject) => {
            ApiService.get(HISTORY_REGION, payload.id).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response)
            });
        })
    },
};

const mutations = {

};
export default {
  state,
  actions,
  mutations,
  getters
};